window.Array.prototype.concatOnce = function(next) {
	let previous = this;
	for (let i = 0; i < next.length; i++) {
		if (this.indexOf(next[i]) === -1) {
			previous.push(next[i]);
		}
	}
	return previous;
};

window.Array.prototype.compare = function(array) {
	if (!array) {
	  return false;
	}
	if (this.length !== array.length) {
	  return false;
	}
	for (var i = 0, l = this.length; i < l; i++) {
	  if (this[i] instanceof Array && array[i] instanceof Array) {
		if (!this[i].compare(array[i])) {
		  return false;
		}
	  }
	  else if (this[i] !== array[i]) {
		return false;
	  }
	}
	return true;
  }